/** @format */

import { Component } from '@angular/core';
import { chain } from '@core/chain';

@Component({
	selector: 'my-account-components-simple-login-header',
	templateUrl: './simple-login-header.component.html',
	styleUrl: './simple-login-header.component.scss',
	standalone: false
})
export class SimpleLoginHeaderComponent {
	public logoUrl = `${chain.simpleHeaderLogoUrl}`;
	public chainName = `${chain.chainName}`;
}
